import React, { type ReactElement } from 'react';

export const MoveIconMedium = (): ReactElement => (
  <svg
    width="116"
    height="100"
    viewBox="0 0 116 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3841_14535)">
      <path
        d="M18.8086 79.1303H58.8286"
        stroke="#031D44"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M18.8086 85.5663L41.9257 85.8139"
        stroke="#031D44"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M96.1965 66.2582H12.5936C8.69935 66.2582 5.55078 69.3937 5.55078 73.2718V91.7548C5.55078 95.633 8.69935 98.7685 12.5936 98.7685H96.1965C100.091 98.7685 103.239 95.633 103.239 91.7548V73.1893C103.239 69.3937 100.091 66.2582 96.1965 66.2582Z"
        stroke="#031D44"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M100.174 63.9478L8.61638 70.2188C4.80495 70.4664 1.49066 67.5784 1.24209 63.7828L-0.000766377 42.9894C-0.249338 39.1938 2.65066 35.8933 6.46209 35.6457L98.0192 29.3747C101.831 29.1272 105.145 32.0152 105.394 35.8108L106.636 56.6041C106.968 60.4822 104.068 63.7003 100.174 63.9478Z"
        fill="#EAF0FA"
      />
      <path
        d="M108.79 0.990173L102.741 5.11584C102.741 5.11584 91.6386 1.23771 86.6672 1.40274C79.5414 1.65028 47.5586 9.73659 47.5586 9.73659C47.5586 9.73659 48.7186 14.0273 53.69 13.3672C55.9272 13.0371 66.6157 10.6442 66.6157 10.6442C66.6157 10.6442 49.7957 21.0409 48.7186 21.536C49.4643 22.6087 52.4472 24.8365 56.7557 22.0311C59.3243 20.2983 75.73 10.6442 75.73 10.6442L68.9357 16.9152L63.4672 37.296C65.0414 37.5436 67.1957 36.3884 67.7757 34.7381C68.3557 33.0879 72.6643 21.6185 72.6643 21.6185C72.6643 21.6185 82.2757 16.4202 86.0872 15.9251C89.8986 15.43 92.0529 22.1136 91.8872 24.6715C91.7214 27.2294 88.9872 30.2824 84.6786 35.7283C71.9186 39.2764 75.8129 45.2998 75.8129 45.2998L86.8329 41.9993C86.8329 41.9993 99.2614 32.4278 104.067 30.7775C108.873 29.1272 113.099 23.6813 113.099 23.6813L115.17 23.3513"
        stroke="#031D44"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M74.7346 3.38306L55.5117 4.20819C55.5117 4.20819 56.4231 7.3437 59.5717 6.7661"
        stroke="#031D44"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.1562 48.9304L56.0934 46.5375"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M16.5703 55.614L39.6046 54.4588"
        stroke="white"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3841_14535">
        <rect width="116" height="99.4286" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
